import stockAPI from "@/utility/api.js";
import { state } from "@/store/reportYear/state.js";
import { getters } from "@/store/reportYear/getters.js";

export const reportYear = {
  state,
  getters,
  mutations: {
    fetchReportYear(state, res) {
      state.reportYear = res;
    },
    fetchErrorMessage(state, error) {
      state.errorMessage = error || "";
    }
  },
  actions: {
    async FETCH_REPORT_YEAR({ commit, rootState }) {
      try {
        const res = await stockAPI.GET(
          `/api/report/year/${rootState.stockSymbol}`
        );
        commit("fetchReportYear", res);
        // 共用 rootState 儲存股票代號。
        commit("storageCompanyName", res, { root: true });
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        // 提示錯誤訊息，優化使用者機制。
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    }
  }
};

// const a = await Promise.allSettled([
//   stockAPI.GET(`/api/report/year/${rootState.stockSymbol}`),
//   stockAPI.GET(`/api/report/${rootState.stockSymbol}`)
// ]);
// console.log(a);
